import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { useRef as v } from "react";
import { BaseCommentContent as p } from "../components/BaseCommentContent/index.js";
import { PublishingCommentFlag as P, ModeratedCommentFlag as u, DeletedCommentFlag as g } from "../components/CommentFlags/index.js";
import { useScrollToComment as x } from "../hooks/useScrollToComment.js";
import { PrivateCommentContainer as A, PrivateCommentAvatar as S, PrivateCommentAuthor as j, PrivateParentComment as y, PrivateContent as z, BannerContainer as B } from "./style.js";
import { AvatarSize as D } from "../../../components/Avatar/style.js";
const b = ({
  image: a,
  authorNickname: t,
  content: l,
  className: d,
  isPending: f,
  isModerated: C,
  isDeleted: c,
  parentComment: r,
  clickoutFunction: s,
  isFocused: o,
  banner: m,
  goToProfile: h
}) => {
  const n = v(null);
  return x({ commentRef: n, isFocused: o }), /* @__PURE__ */ e(
    A,
    {
      ref: n,
      "data-focused": o,
      className: d,
      children: /* @__PURE__ */ e(
        p,
        {
          header: /* @__PURE__ */ i(
            "div",
            {
              style: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
              },
              children: [
                /* @__PURE__ */ e(
                  S,
                  {
                    goToProfile: h,
                    author: t,
                    authorImage: a,
                    size: D.SMALL
                  }
                ),
                /* @__PURE__ */ e(j, { children: t }),
                f && /* @__PURE__ */ e(P, {}),
                C && /* @__PURE__ */ e(u, {}),
                c && /* @__PURE__ */ e(g, {})
              ]
            }
          ),
          content: /* @__PURE__ */ i("div", { children: [
            r && /* @__PURE__ */ e(y, { ...r }),
            /* @__PURE__ */ e(z, { clickoutFunction: s, children: l }),
            m && /* @__PURE__ */ e(B, { children: m })
          ] })
        }
      )
    }
  );
};
export {
  b as PrivateComment
};
